import React from 'react';

import { Container } from './styles';

import { ButtonProps } from './interface';

const Button: React.FC<ButtonProps> = ({
  onClick,
  children,
  type,
  ...rest
}) => {
  return (
    <Container {...rest} onClick={onClick}>
      <>{children}</>
    </Container>
  );
};

export default Button;
